import React from "react";
import * as Icons from "lucide-react";
import { ICONS_BY_NAME } from "../lib/icons";

export const Skeleton = ({ className = "" }) => <div className={`skeleton ${className}`} />;

export const CardsSkeleton = ({ count = 3, cols = 3 }) => (
  <div className={`grid gap-4 sm:grid-cols-2 lg:grid-cols-${cols}`}>
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="bg-sable rounded-2xl border border-marine/10 p-5">
        <Skeleton className="h-5 w-20 mb-4" />
        <Skeleton className="h-6 w-3/4 mb-2" />
        <Skeleton className="h-4 w-1/2 mb-5" />
        <Skeleton className="h-2 w-full" />
      </div>
    ))}
  </div>
);

export const PageSkeleton = () => (
  <div className="animate-fade-up">
    <Skeleton className="h-3 w-24 mb-3" />
    <Skeleton className="h-10 w-72 mb-10" />
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4 mb-10">
      {Array.from({ length: 4 }).map((_, i) => <div key={i} className="bg-sable rounded-2xl border border-marine/10 p-5"><Skeleton className="h-4 w-16 mb-3" /><Skeleton className="h-8 w-20" /></div>)}
    </div>
    <CardsSkeleton count={3} />
  </div>
);

export const EmptyState = ({ icon = "Inbox", title, hint, action }) => {
  const Ic = ICONS_BY_NAME[icon] || Icons.Inbox;
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6 animate-fade-up" data-testid="empty-state">
      <div className="w-14 h-14 rounded-2xl bg-sable-clair flex items-center justify-center mb-4">
        <Ic size={16} className="text-bordeaux" strokeWidth={1.5} />
      </div>
      <div className="font-display text-lg text-marine">{title}</div>
      {hint && <div className="text-sm text-marine/80 mt-1 max-w-sm">{hint}</div>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
};
